<template>
  <div class="animated fadeIn">
    <basic-heading title="Analytes">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list analyte'">
      <template #gated-content>
        <analyte-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import AnalyteServerTable from "@/components/lab/analyte/AnalyteServerTable";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "AnalyteIndex",
  components: {
    AnalyteServerTable,
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/analytes/add",
            title: "Add analyte",
            variant: "success",
            permission: this.checkPermission("add analyte"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
